// src/App.js
import React, { useState } from 'react';
import { Tab, Tabs, TabList, TabPanel } from 'react-tabs';
import 'react-tabs/style/react-tabs.css';

import IntroTab from './components/IntroTab';
import ProtagsTab from './components/ProtagsTab';
import IncitingIncidentTab from './components/IncitingIncidentTab';
import PlotPointsTab from './components/PlotPointsTab';
import DarkMomentTab from './components/DarkMomentTab';
import ConclusionTab from './components/ConclusionTab';

function App() {

  const [formData, setFormData] = useState({
    intro: {},
    protags: {},
    incitingIncident: {},
    plotPoints: {},
    darkMoment: {},
    conclusion: {},
  });

  const handleFormChange = (tabName, data) => {
    setFormData((prevData) => ({
      ...prevData,
      [tabName]: data,
    }));
  };

  const generateSynopsis = () => {
    const synopsisData = {
      ...formData.intro,
      ...formData.protags,
      ...formData.incitingIncident,
      ...formData.plotPoints,
      ...formData.darkMoment,
      ...formData.conclusion,
    };

    const synopsisOutput = Object.entries(synopsisData)
    .map(([key, value]) => `${value}`)
    .join('\n');


    return synopsisOutput;
  };


  return (
    <div className='tab-styling'>
      <Tabs>
        <TabList>
          <Tab>Intro</Tab>
          <Tab>Protags</Tab>
          <Tab>Inciting Incident</Tab>
          <Tab>Plot Points</Tab>
          <Tab>Dark Moment</Tab>
          <Tab>Conclusion</Tab>
        </TabList>

        <TabPanel>
          <IntroTab data={formData.intro} onChange={(data) => handleFormChange('intro', data)} />
        </TabPanel>
        <TabPanel>
          <ProtagsTab data={formData.protags} onChange={(data) => handleFormChange('protags', data)} />
        </TabPanel>
        <TabPanel>
          <IncitingIncidentTab data={formData.incitingIncident} onChange={(data) => handleFormChange('incitingIncident', data)} />
        </TabPanel>
        <TabPanel>
          <PlotPointsTab data={formData.plotPoints} onChange={(data) => handleFormChange('plotPoints', data)} />
        </TabPanel>
        <TabPanel>
          <DarkMomentTab data={formData.darkMoment} onChange={(data) => handleFormChange('darkMoment', data)} />
        </TabPanel>
        <TabPanel>
          <ConclusionTab formData={formData.conclusion} onChange={(data) => handleFormChange('conclusion', data)} />
        </TabPanel>
      </Tabs>
      <br/>
      <br />
      <div className="nice-form-group">

        <h4>Output:</h4>
      <textarea
            id="synopsisoutput"
          
            value={generateSynopsis()}
            readOnly
          />
          </div>
    </div>
  );
}

export default App;
